import { css } from "@microsoft/fast-element";
import { colorNeutralBackground1, colorNeutralForeground3, colorNeutralForegroundDisabled, fontFamilyBase, fontSizeBase200, fontWeightSemibold, lineHeightBase200, spacingHorizontalM, spacingVerticalS, spacingVerticalXS } from "@fluentui/web-components";
/**
 * Styles for the {@link @fabric-msft/fabric-web#(OptionGroup:class)} component.
 *
 * @public
 */
export const styles = css `
  :host {
    display: block;
    font-family: ${fontFamilyBase};
  }

  :host([hidden]) {
    display: none;
  }

  .label {
    color: ${colorNeutralForeground3};
    font-size: ${fontSizeBase200};
    font-weight: ${fontWeightSemibold};
    line-height: ${lineHeightBase200};
    padding-block: ${spacingVerticalXS};
    padding-inline: ${spacingHorizontalM};
    user-select: none;
    cursor: default;
  }

  :host([disabled]) .label {
    color: ${colorNeutralForegroundDisabled};
  }

  :host([disabled]) ::slotted(*) {
    color: ${colorNeutralForegroundDisabled};
    background-color: ${colorNeutralBackground1};
    cursor: default;
  }

  .options {
    display: flex;
    flex-direction: column;
    padding-block-end: ${spacingVerticalS};
  }
`;
//# sourceMappingURL=option-group.styles.js.map